import '@smzh/kit/smzh-accordion';
import '@smzh/kit/smzh-accordion-item';
import '@smzh/kit/smzh-advisor-callout';
import '@smzh/kit/smzh-avatar';
import '@smzh/kit/smzh-avatar-group';
import '@smzh/kit/smzh-badge';
import '@smzh/kit/smzh-blog-card';
import '@smzh/kit/smzh-budget-chart';
import '@smzh/kit/smzh-budget-line-item';
import '@smzh/kit/smzh-budget-overview';
import '@smzh/kit/smzh-button';
import '@smzh/kit/smzh-calculator-layout';
import '@smzh/kit/smzh-checkbox';
import '@smzh/kit/smzh-date-picker';
import '@smzh/kit/smzh-dropdown';
import '@smzh/kit/smzh-error-callout';
import '@smzh/kit/smzh-illustration';
import '@smzh/kit/smzh-input';
import '@smzh/kit/smzh-loader';
import '@smzh/kit/smzh-modal';
import '@smzh/kit/smzh-mortgage-affordability-chart';
import '@smzh/kit/smzh-option-group';
import '@smzh/kit/smzh-progress-indicator';
import '@smzh/kit/smzh-radio';
import '@smzh/kit/smzh-radio-card';
import '@smzh/kit/smzh-rate-range-chart';
import '@smzh/kit/smzh-rating-scale';
import '@smzh/kit/smzh-recommendation-callout';
import '@smzh/kit/smzh-savings-chart';
import '@smzh/kit/smzh-select';
import '@smzh/kit/smzh-slider';
import '@smzh/kit/smzh-success-state';
import '@smzh/kit/smzh-tabs';
import '@smzh/kit/smzh-tabs-group';
import '@smzh/kit/smzh-textarea';
import '@smzh/kit/smzh-tip-card';
import '@smzh/kit/smzh-tile';
import '@smzh/kit/smzh-tile-group';
import '@smzh/kit/smzh-toggle';
import '@smzh/kit/smzh-tooltip';
import '@smzh/kit/smzh-typography';
import '@smzh/kit/smzh-valuation-range-chart';
import 'd3-transition';
import { html, nothing } from 'lit';

const budgetChartElement = customElements.get('smzh-budget-chart') as
  | (CustomElementConstructor & {
      prototype: {
        render?: () => unknown;
        getTotal?: (segments: unknown[]) => number;
        getResolvedSegments?: () => unknown[];
        formatTotal?: (total: number) => string;
        subtitle?: string;
        centerEntranceActive?: boolean;
        __smzhClientAppRenderPatched?: boolean;
      };
    })
  | undefined;

if (
  budgetChartElement?.prototype.render &&
  !budgetChartElement.prototype.__smzhClientAppRenderPatched
) {
  budgetChartElement.prototype.__smzhClientAppRenderPatched = true;

  budgetChartElement.prototype.render = function () {
    const segments = this.getResolvedSegments?.() ?? [];
    const total = this.getTotal?.(segments) ?? 0;
    const amountLabel = this.formatTotal?.(total) ?? `CHF ${total}`;
    const subtitle = this.subtitle ?? 'Gesamtausgaben';

    return html`
      <div
        class="chart-wrap"
        aria-label=${`${amountLabel}, ${subtitle}`}
        data-entering=${this.centerEntranceActive ? '' : nothing}
      >
        <div class="center-disc" aria-hidden="true"></div>
        <svg class="chart-svg" role="img" aria-hidden="true"></svg>
        <div class="center">
          <p class="amount"></p>
          <p class="subtitle"></p>
        </div>
      </div>
    `;
  };
}

export {};
